import { Fragment } from "react";
import { Link } from "react-router-dom";

export const Home = () => (
    <Fragment>
        <li><Link to="/">Home 01</Link></li>
        <li><Link to="/home-two">Home 02</Link></li>
        <li><Link to="/home-three">Home 03</Link></li>
    </Fragment>
);
export const Page = () => (
    <Fragment>
    <li><Link to="/tournaments">Tournaments</Link></li>
    </Fragment>
);
export const Portfolio = () => (
    <Fragment>
    <li><Link to="/news">News</Link></li>
    </Fragment>
);
export const News = () => (
    <Fragment>
    <li><Link to="/prorating">Pro rating</Link></li>
    <li><Link to="/amateur">Amateur Rating</Link></li>
    <li><Link to="/female">Female Rating</Link></li>
    <li><Link to="/orgrating">Org Rating</Link></li>
    {/* <li><Link to="/news-details">News Details</Link></li> */}
    </Fragment>
);
